export const Roles = {
	POS_STANDARD_USER: "PoS Standard User",
}